import React from 'react';
import PropTypes from 'prop-types';
import PhotoVideoCard from './PhotoVideoCard'; 

const PhotoVideo = (props) => { 
    const bigCard = props.docs.splice(0, 1).map(
        item => (<PhotoVideoCard key={`big_card_${item.title}`} cardSize="card_big" data={item} />)
    );
    const smallCard = props.docs.splice(4, 8).map(
        item => (<PhotoVideoCard key={`small_card_${item.title}`} cardSize="card_small" data={item} />)
    );
    const mediumCard = props.docs.splice(0, 4).map(
        item => (<PhotoVideoCard key={`medium_card_${item.title}`} cardSize="card_medium" data={item} />)
    );
    
    return ( 
        <section className="photovideo photovideo__cards">
            {bigCard} {mediumCard} <div className="small_card_wrapper">{smallCard}</div>
        </section>
    );
};

PhotoVideo.propTypes = { 
    docs: PropTypes.arrayOf(PropTypes.any)
};

PhotoVideo.defaultProps = {  
    docs: []
};

export default PhotoVideo;



// WEBPACK FOOTER //
// ./src/components/PhotoVideo.jsx